import React from 'react';
import ReactDOM from 'react-dom/client';
import Root from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);
